// Konstanty modulu "Úpravy trenažérů" – stavy zakázky, druhy položek, texty příznaků a tlačítek přechodů.
// Stavy musí odpovídat services/upgrades/workflow.js na serveru.

export const UPGRADE_STATUSES = [
  { value: 'navrh',            label: 'Návrh',             short: 'Návrh',      bg: '#EFEFEF', color: '#555555' },
  { value: 'nabidka_odeslana', label: 'Nabídka odeslána',  short: 'Nabídka',    bg: '#E3F2FD', color: '#1565C0' },
  { value: 'schvaleno',        label: 'Schváleno',         short: 'Schváleno',  bg: '#E8F5E9', color: '#2E7D32' },
  { value: 'naplanovano',      label: 'Naplánováno',       short: 'Naplánováno', bg: '#FFF3E0', color: '#E65100' },
  { value: 'probiha',          label: 'Probíhá',           short: 'Probíhá',    bg: '#F3E5F5', color: '#6A1B9A' },
  { value: 'dokonceno',        label: 'Dokončeno',         short: 'Dokončeno',  bg: '#E0F2F1', color: '#00695C' },
  { value: 'zruseno',          label: 'Zrušeno',           short: 'Zrušeno',    bg: '#FFEBEE', color: '#C62828' },
];

export const UPGRADE_STATUS = Object.fromEntries(UPGRADE_STATUSES.map((s) => [s.value, s]));

// Kroky v ukazateli průběhu na detailu (zrušeno je mimo)
export const PIPELINE = ['navrh', 'nabidka_odeslana', 'schvaleno', 'naplanovano', 'probiha', 'dokonceno'];
export const CLOSED_STATUSES = ['dokonceno', 'zruseno'];

export const ITEM_KINDS = [
  { value: 'dil', label: 'Díl' },
  { value: 'prace', label: 'Práce' },
  { value: 'doprava', label: 'Doprava' },
  { value: 'jine', label: 'Jiné' },
];

export const FLAG_LABELS = {
  quote_expired: 'Nabídce vypršela platnost',
  needs_followup: 'Připomeňte se zákazníkovi',
  unscheduled: 'Čeká na naplánování',
  overdue: 'Po termínu',
  starts_soon: 'Brzy se jede',
};

// "z>do": [text tlačítka, tón]
export const TRANSITION_UI = {
  'navrh>nabidka_odeslana': ['Nabídka odeslána zákazníkovi', 'primary'],
  'navrh>schvaleno': ['Schváleno bez nabídky', 'secondary'],
  'navrh>zruseno': ['Zrušit úpravu', 'danger'],
  'nabidka_odeslana>schvaleno': ['Zákazník schválil nabídku', 'primary'],
  'nabidka_odeslana>navrh': ['Zpět do návrhu', 'secondary'],
  'nabidka_odeslana>zruseno': ['Zákazník odmítl – zrušit', 'danger'],
  'schvaleno>nabidka_odeslana': ['Vrátit k nabídce', 'secondary'],
  'schvaleno>naplanovano': ['Označit jako naplánováno', 'primary'],
  'schvaleno>zruseno': ['Zrušit úpravu', 'danger'],
  'naplanovano>probiha': ['Zahájit práce na místě', 'primary'],
  'naplanovano>schvaleno': ['Zrušit plán výjezdu', 'secondary'],
  'naplanovano>zruseno': ['Zrušit úpravu', 'danger'],
  'probiha>dokonceno': ['Dokončit úpravu', 'primary'],
  'probiha>naplanovano': ['Vrátit na naplánováno', 'secondary'],
  'probiha>zruseno': ['Zrušit úpravu', 'danger'],
  'dokonceno>probiha': ['Znovu otevřít', 'secondary'],
  'zruseno>navrh': ['Obnovit jako návrh', 'secondary'],
};

// Names of the edited fields shown in the history ("Upraveno: termín, posádka")
export const FIELD_LABELS = {
  title: 'název', description: 'zadání', internal_notes: 'interní poznámka', completion_notes: 'poznámka z výjezdu', location: 'adresa',
  site_id: 'provozovna', contact_name: 'kontakt', contact_phone: 'telefon', contact_email: 'e-mail',
  planned_start: 'termín od', planned_end: 'termín do', arrival_time: 'čas příjezdu', quote_valid_until: 'platnost nabídky',
  discount_percent: 'sleva', machine_ids: 'trenažéry', crew: 'posádka', items: 'výpis změn',
};

export const ACTION_LABELS = {
  create: 'Založeno', update: 'Upraveno', status: 'Změna stavu', travel: 'Přepočtena doprava', delete: 'Smazáno',
  template_create: 'Uloženo do šablon', ai_import: 'AI načetla dokument',
};
